import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SeasonService, ReferenceDateSetting, SeasonWithCurrentView } from '../../api';

@Component({
    selector: 'app-edit-reference-date-form',
    templateUrl: './edit-reference-date-form.component.html',
    standalone: false
})
export class EditReferenceDateFormComponent implements OnInit {
  public seasons: SeasonWithCurrentView[] = [];
  public form!: FormGroup;
  public isEdit = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public passedData: any,
    private seasonService: SeasonService,
    public dialogRef: MatDialogRef<EditReferenceDateFormComponent>
  ) {}

  ngOnInit() {
    const existingData: ReferenceDateSetting = this.passedData.payload;
    const existingReferenceDates: ReferenceDateSetting[] = this.passedData.existingReferenceDates || [];
    this.isEdit = !!existingData;

    this.form = new FormGroup({
      SeasonId: new FormControl({ value: existingData?.SeasonId || '', disabled: this.isEdit }, Validators.required),
      BeforeAfter: new FormControl(existingData?.BeforeAfter || 'B', Validators.required),
      Date: new FormControl(existingData?.Date ? existingData.Date : null, Validators.required)
    });

    this.seasonService.getAllSeasonsWithCurrent().subscribe((data) => {
      if (this.isEdit) {
        this.seasons = data.filter(season => season.Id === existingData.SeasonId);
      } else {
        const now = new Date();
        const existingSeasonIds = existingReferenceDates.map(rd => rd.SeasonId);
        
        this.seasons = data.filter(season => {
          const endDate = new Date(season.EndDate!);
          const hasFutureEndDate = endDate > now;
          const hasNoReferenceDate = !existingSeasonIds.includes(season.Id);
          return hasFutureEndDate && hasNoReferenceDate;
        });
      }
    });
  }

  submit() {
    const formValue = this.form.getRawValue();
    const existingData: ReferenceDateSetting = this.passedData.payload;
    const season = this.seasons.find(s => s.Id === formValue.SeasonId);
    
    const result: ReferenceDateSetting = {
      Id: existingData?.Id || 0,
      SeasonId: formValue.SeasonId,
      SeasonName: season?.Name || '',
      BeforeAfter: formValue.BeforeAfter,
      Date: formValue.Date
    };

    this.dialogRef.close(result);
  }
}
